import React from "react";
import styled from "styled-components";
import ButtonWithText from "./Button";
import { colors } from "./colors";
import { rgba } from "polished";

const Label = styled.span`
    color: ${({ variant }) => colors[variant][900]};
    font-size: ${(props) => props.style?.fontSize || "14px"};
    cursor: pointer;
    font-weight: 500;
    line-height: 1;
`;

const StyledButton = styled(ButtonWithText)`
    width: 20px;
    height: 20px;
`;

const Container = styled.div`
    display: flex;
    align-items: center;
    gap: ${({ buttonStyle }) => (buttonStyle === "borderless" ? "0" : "8px")};

    ${({ hover = true, variant = "primary" }) =>
        hover &&
        `
        &:hover {
            ${Label} {
                text-decoration: underline;
                color: ${colors[variant][950]};
            }

            ${StyledButton} {
                background-color: ${colors[variant][950]};
                box-shadow: 0 4px 8px ${rgba(colors[variant][950], 0.2)};
            }
        }

        &:active {
            ${Label} {
                color: ${colors[variant][900]};
            }

            ${StyledButton} {
                background-color: ${colors[variant][900]};
                color: ${colors[variant][200]};
                box-shadow: inset 0 2px 4px ${rgba(colors[variant][950], 0.2)};
            }
        }
    `}
`;

const ButtonWithLabel = ({ label, labelPosition = "right", labelStyle, children, style, ...props }) => {
    const content = (
        <>
            <StyledButton {...props}>{children}</StyledButton>
            <Label {...props} style={labelStyle}>
                {label}
            </Label>
        </>
    );

    return (
        <Container style={style} {...props}>
            {labelPosition === "left" ? content.reverse() : content}
        </Container>
    );
};

export default ButtonWithLabel;
